import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  Alert
} from '@mui/material';
import { Login, VpnKey } from '@mui/icons-material';

import ClientAPI from '../service/ClientAPI';
import Events from '../service/Events';
import CookieManager from '../managers/CookieManager';
import LocalStorageManager from '../managers/LocalStorageManager';

class ReLoginPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      title: "",
      email: null,
      password: null,
      resetPassword: false,
      errorMessage: null,
      mailSentMessage: null
    }
  }

  handleShow = (title) => this.setState({ show: true, title });

  handleClose = () => this.setState({ show: false, errorMessage: null, mailSentMessage: null });

  handleChange = (ev) => {
    var name = ev.target.name;
    this.setState({ [name]: ev.target.value });
  }

  handleLogin = (ev) => {
    this.setState({ errorMessage: null });

    ClientAPI.Login({
      password: this.state.password,
      email: this.state.email
    })
      .then((_res) => {
        CookieManager.Save("auth", _res.token);
        LocalStorageManager.Save("admin", _res.isAdmin);

        if (ev.target.save.checked) {
          LocalStorageManager.SaveMultiple([
            { key: "isSaved", value: true },
            { key: "password", value: this.state.password },
            { key: "email", value: this.state.email }
          ]);
        }

        window.location.reload();
      })
      .catch(console.error);

    ev.preventDefault();
  }

  handleRelogin = () => new Promise((res, rej) => {
    if (LocalStorageManager.Get("isSaved")) {
      ClientAPI.Login({
        password: LocalStorageManager.Get("password"),
        email: LocalStorageManager.Get("email")
      })
        .then((_res) => {
          CookieManager.Save("auth", _res.token);
          LocalStorageManager.Save("admin", _res.isAdmin);

          window.location.reload();

          res(_res);
        })
        .catch((_e) => {
          this.handleShow("Ihre alten Daten sind nicht mehr gültig!");
          rej(_e);
        });
    }

    rej("Keine Logindaten gefunden!");
  });

  handleResetPassword = (ev) => {
    ev.preventDefault();

    CookieManager.Delete("auth");
    LocalStorageManager.DeleteMultiple(["admin", "isSaved", "password", "email"]);

    ClientAPI.RequestResetPassword(ev.target.email.value)
      .then((_res) => {
        this.setState({ mailSentMessage: "Email wurde versendet" })
        Events.onResult.emit("success");
      })
      .catch(console.error);
  }

  handleErrorMessage = (errorMessage) => {
    this.setState({ errorMessage: errorMessage });
  }

  componentDidMount() {
    if (window.location.href.includes("register")
      || window.location.href.includes("resetPassword")
      || window.location.href.includes("impressum")
    ) return;

    Events.onResult.on("onAuthTokenInvalid", () => {
      this.handleRelogin()
        .catch((e) => {
          this.handleShow("Ihre Session ist abgelaufen, bitte erneut einloggen um die Daten abzurufen.");
        })
    });

    Events.onResult.on("error", this.handleErrorMessage);

    if (!CookieManager.Get("auth")) {
      this.handleRelogin()
        .catch((e) => {
          this.handleShow("Ihre Session ist abgelaufen, bitte erneut einloggen um die Daten abzurufen.");
        });
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.show}
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: '12px', sm: '20px' },
            overflow: 'hidden',
            margin: { xs: '16px', sm: '32px' },
            maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
          }
        }}
      >
        {/* Header with gradient */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
            pt: { xs: 3, sm: 4 },
            pb: { xs: 2.5, sm: 3 },
            px: { xs: 2, sm: 3 },
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1.5, sm: 2 }
          }}
        >
          {this.state.resetPassword ? (
            <VpnKey sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
          ) : (
            <Login sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
          )}
          <DialogTitle sx={{ p: 0, flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
              {this.state.title}
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
          <Box component="form" onSubmit={!this.state.resetPassword ? this.handleLogin : this.handleResetPassword} id="relogin-form">
            <TextField
              fullWidth
              type="email"
              name="email"
              label="E-Mail"
              placeholder="E-Mail eingeben"
              onChange={this.handleChange}
              sx={{ mb: 3 }}
            />

            {!this.state.resetPassword ? (
              <Box>
                <TextField
                  fullWidth
                  type="password"
                  name="password"
                  label="Passwort"
                  placeholder="Passwort"
                  onChange={this.handleChange}
                  sx={{ mb: 2 }}
                />

                <FormControlLabel
                  control={<Checkbox name="save" />}
                  label="Anmeldedaten speichern"
                  sx={{ mb: 3 }}
                />

                {this.state.errorMessage && (
                  <Alert severity="error" sx={{ mb: 2, borderRadius: '12px' }}>
                    {this.state.errorMessage}
                  </Alert>
                )}
              </Box>
            ) : (
              this.state.mailSentMessage && (
                <Alert severity="success" sx={{ borderRadius: '12px' }}>
                  {this.state.mailSentMessage}
                </Alert>
              )
            )}
          </Box>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ 
          p: { xs: 2, sm: 3 }, 
          gap: { xs: 1.5, sm: 2 }, 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between' 
        }}>
          {!this.state.resetPassword ? (
            <Button
              onClick={() => this.setState({ resetPassword: true, errorMessage: null })}
              variant="outlined"
              fullWidth
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                borderColor: '#ddd',
                color: '#666',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                py: { xs: 1.2, sm: 1.5 },
                order: { xs: 2, sm: 1 },
                '&:hover': {
                  borderColor: '#bbb',
                  bgcolor: '#f5f5f5'
                }
              }}
            >
              Passwort vergessen
            </Button>
          ) : (
            <Button
              onClick={() => this.setState({ resetPassword: false, mailSentMessage: null })}
              variant="outlined"
              fullWidth
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                borderColor: '#ddd',
                color: '#666',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                py: { xs: 1.2, sm: 1.5 },
                order: { xs: 2, sm: 1 },
                '&:hover': {
                  borderColor: '#bbb',
                  bgcolor: '#f5f5f5'
                }
              }}
            >
              Einloggen
            </Button>
          )}

          <Button
            type="submit"
            form="relogin-form"
            variant="contained"
            size="large"
            fullWidth
            startIcon={this.state.resetPassword ? <VpnKey /> : <Login />}
            sx={{
              bgcolor: '#2e7d32',
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              py: { xs: 1.2, sm: 1.5 },
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
              order: { xs: 1, sm: 2 },
              '&:hover': {
                bgcolor: '#1b5e20',
                boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.2s ease'
            }}
          >
            {this.state.resetPassword ? 'Passwort zurücksetzen' : 'Einloggen'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ReLoginPopup;
